export class BasicRightInformation {
    public id: string;
    public name: string | null = '';

    constructor();
    constructor(rightId: string, rightName: string | null);
    constructor(rightId?: string, rightName?: string | null) {
        if (rightId !== undefined) {
            this.id = rightId;
        }
        
        if (rightName !== undefined) {
            this.name = rightName;
        }        
    }
}